import { OrganizationUser } from '../../domain/organization/OrganizationUser';
import { OrganizationUserDTO } from '../../domain/organization/OrganizationUserDTO';

export class OrganizationUserMapper {
  static toDomain(props: OrganizationUserDTO): OrganizationUser {
    const { id, email, first_name, last_name, role, avatar_url, validated, deleted, created_at } = props;

    return OrganizationUser.create(
      {
        email,
        first_name,
        last_name,
        role,
        avatar_url,
        validated,
        deleted,
        created_at,
      },
      id
    );
  }
}
